import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Png: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3568)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M26.0312 41.7813C26.0312 43.0938 25.5938 44.1875 24.7188 45.0625C23.8438 45.9375 22.75 46.1563 21.2187 46.1563H20.3438V50.3125H17.0625V37.8438H21.4375C22.9688 37.8438 24.2812 38.2812 24.9375 38.9375C25.5937 39.5938 26.0312 40.4688 26.0312 41.7813ZM20.3438 43.3125H21C21.4375 43.3125 21.875 43.0938 22.3125 42.875C22.75 42.6563 22.75 42.2188 22.75 41.7813C22.75 40.9063 22.3125 40.4688 21.4375 40.4688H20.3438V43.3125Z"
          fill="white"
        />
        <path
          d="M40.0312 50.3125H35.6562L31.0625 41.5625C31.0625 42.875 31.2813 43.9688 31.2813 44.625V50.3125H28.2188V37.8438H32.5938L37.1875 46.5938C37.1875 45.2812 36.9688 44.4063 36.9688 43.5313V37.8438H40.0312V50.3125Z"
          fill="white"
        />
        <path
          d="M47.6875 43.0938H53.1562V49.875C51.625 50.3125 50.0938 50.5312 48.3438 50.5312C46.375 50.5312 44.8438 49.875 43.9688 48.7812C43.0938 47.6875 42.4375 46.1562 42.4375 43.9688C42.4375 42 43.0938 40.4687 44.1875 39.1562C45.2813 37.8437 47.0312 37.4062 49 37.4062C49.875 37.4062 50.5312 37.4063 51.1875 37.625C51.8438 37.8438 52.5 38.0625 52.9375 38.2812L51.8438 40.9063C50.9688 40.4688 49.875 40.25 48.7812 40.25C47.6875 40.25 47.0312 40.4687 46.5937 41.125C46.1562 41.7812 45.7188 42.6562 45.7188 43.9688C45.7188 45.0625 45.9375 45.9375 46.375 46.5937C46.8125 47.25 47.4688 47.4688 48.5625 47.4688C49 47.4688 49.4375 47.4688 49.875 47.25V45.2813H47.6875V43.0938Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
